<div class="candidate-login-container">
  <div class="login-wrapper">
    <!-- Left Section - Form -->
    <div class="form-section">
      <div class="branding-section">
        <div class="evaltrix-logo">Evaltrix</div>
        <div class="invitation-text">
          <strong>Reset Your Password</strong>
        </div>
        <div class="powered-by">
          Create a strong new password to secure your account.
        </div>
      </div>

      <div class="form-container">
        <form class="login-form" [formGroup]="confirmPwdForm" (ngSubmit)="confirmPwdSubmit()">

          <!-- New Password Field -->
          <div class="form-group">
            <label class="form-label">New Password</label>
            <mat-form-field class="custom-field" appearance="outline">
              <input [type]="hidePassword ? 'password' : 'text'" matInput placeholder="Enter new password"
                formControlName="password" [ngClass]="{ 'is-invalid': submitted && f.password.errors }">
              <mat-icon matSuffix class="field-icon clickable" (click)="togglePasswordVisibility()">
                {{ hidePassword ? 'visibility_off' : 'visibility' }}
              </mat-icon>
              <mat-error *ngIf="f.password.errors?.required">Password is required</mat-error>
              <mat-error *ngIf="f.password.errors?.minlength">Password must be at least 6 characters</mat-error>
            </mat-form-field>
          </div>

          <!-- Confirm Password Field -->
          <div class="form-group">
            <label class="form-label">Confirm Password</label>
            <mat-form-field class="custom-field" appearance="outline">
              <input [type]="hideConfirmPassword ? 'password' : 'text'" matInput placeholder="Confirm your password"
                formControlName="confirmPassword" (input)="validateConfirmPassword()">
              <mat-icon matSuffix class="field-icon clickable" (click)="toggleConfirmPasswordVisibility()">
                {{ hideConfirmPassword ? 'visibility_off' : 'visibility' }}
              </mat-icon>
              <mat-error *ngIf="f.confirmPassword?.errors?.mustMatch">Passwords must match</mat-error>
            </mat-form-field>
          </div>



          <!-- Submit Button -->
          <button type="submit" #setPasswordBtn class="submit-button" mat-raised-button
            [disabled]="confirmPwdForm.invalid">
            <span>Set New Password</span>
            <mat-icon>arrow_forward</mat-icon>
          </button>
        </form>
      </div>
    </div>

    <!-- Right Section - Illustration -->
    <div class="illustration-section">
      <div class="illustration-content">
        <div class="illustration-wrapper">
          <svg viewBox="0 0 500 500" xmlns="http://www.w3.org/2000/svg">
            <!-- Background decoration -->
            <circle cx="250" cy="200" r="180" fill="#E8F4FF" opacity="0.5" />

            <!-- Shield with lock -->
            <path d="M 250 120 L 200 140 L 200 220 C 200 260 225 280 250 290 C 275 280 300 260 300 220 L 300 140 Z"
              fill="#667eea" stroke="#5568d3" stroke-width="2" />

            <!-- Lock icon on shield -->
            <rect x="235" y="180" width="30" height="35" rx="3" fill="white" opacity="0.9" />
            <path d="M 240 180 L 240 170 C 240 162 245 157 250 157 C 255 157 260 162 260 170 L 260 180" stroke="white"
              stroke-width="3" fill="none" />
            <circle cx="250" cy="195" r="4" fill="#667eea" />

            <!-- Person illustration -->
            <circle cx="250" cy="350" r="35" fill="#FFB84D" />
            <path d="M 215 390 Q 215 365 250 365 Q 285 365 285 390 L 285 420 L 215 420 Z" fill="#4A5568" />

            <!-- Checkmark circle -->
            <circle cx="320" cy="160" r="25" fill="#10B981" opacity="0.9" />
            <path d="M 310 160 L 316 166 L 330 152" stroke="white" stroke-width="4" fill="none" stroke-linecap="round"
              stroke-linejoin="round" />

            <!-- Decorative elements -->
            <circle cx="150" cy="280" r="8" fill="#FFB84D" opacity="0.6" />
            <circle cx="360" cy="300" r="10" fill="#667eea" opacity="0.4" />
            <circle cx="180" cy="380" r="6" fill="#10B981" opacity="0.5" />
          </svg>
        </div>
        <div class="illustration-text">
          <h2>Secure Your Account</h2>
          <p>Create a strong password to protect your information and maintain account security.</p>
        </div>
      </div>
    </div>
  </div>
</div>